const initialState = {
  tokenAxios: false
}

const TokenAxios = (state = initialState, action) => {
  switch (action.type) {
    case "TOKEN_AXIOS":
      return { ...state, tokenAxios: action.val }
    default:
      return state
  }
}

export default TokenAxios
